module.exports = __webpack_public_path__ + "static/lights28-87525e3b85e1491cf97afc5f29328aac.jpg";